import AppHeader from '../AppHeader'

export default {
  name: 'master-stock',
  created () {
    window.sessionStorage.removeItem('master_consumable_item_search')
  },
  computed: {
  },
  components: {
    AppHeader
  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/master-stock.js